<template lang="html">
  <div class="pagination">
    <ul>
      <li
        v-if="pageCount >= 0"
        :class="{disabled: curPage === 1 || pageCount === 0}"
        @click="prevPage"
      >
        <
      </li>
      <li
        v-if="pageCount !== 0"
        :class="{active: curPage === 1}"
        @click="page(null,1)"
      >
        <span>1</span>
      </li>
      <li
        v-show="curPage > 5 && pageCount > 10"
        class="ellipsis"
      >
        ...
      </li>
      <li
        v-for="(item,index) in middlePages"
        :class="{active: curPage === index+offset}"
        @click="page(null, index+offset)"
      >
        <span>{{ index+offset }}</span>
      </li>
      <li
        v-show="curPage < bigLimit && pageCount > 10"
        class="ellipsis"
      >
        ...
      </li>
      <li
        v-if="pageCount > 1"
        :class="{active: curPage === pageCount}"
        @click="page(null, pageCount)"
      >
        <span>{{ pageCount }}</span>
      </li>
      <li
        v-if="pageCount >= 0"
        :class="{disabled: curPage === pageCount || pageCount === 0}"
        @click="nextPage"
      >
        >
      </li>
    </ul>
    <p class="desc">
      共{{ totalCount }}条，每页{{ perPageSize }}条
    </p>
  </div>
</template>

<script>
export default {
  props: {
    pageCount: {
      type: Number,
      default: 1
    },
    initPage: {
      type: Number,
      default: 1
    },
    totalCount: {
      type: Number,
      default: 0
    },
    perPageSize: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      curPage: 1
    }
  },
  computed: {
    middlePages() {
      if (this.pageCount <= 2) {
        return 0
      } else if (this.pageCount > 2 && this.pageCount <= 10) {
        return this.pageCount - 2
      } else {
        return this.curPage > 999 ? 5 : 8
      }
    },
    bigLimit() {
      return this.middlePages > 5 ? this.pageCount - 6 : this.pageCount - 3
    },
    offset() {
      if (this.curPage <= 5) {
        return 2
      } else if (this.curPage >= this.bigLimit) {
        const temp = this.bigLimit - 2
        return temp < 2 ? 2 : temp
      } else {
        return this.middlePages > 5 ? this.curPage - 3 : this.curPage - 2
      }
    }
  },
  watch: {
    initPage(val) {
      this.curPage = val
    }
  },
  created() {
    if (this.initPage !== 1 && this.initPage) {
      this.curPage = Number(this.initPage)
    }
  },
  methods: {
    setPage(page = 1) {
      this.curPage = page
    },
    page(e, cur) {
      let n
      if (!e) {
        n = cur
      } else {
        let target = e.target
        n = target.innerText
      }
      if (Number(n)) {
        this.$emit('togglePage', Number(n))
        this.curPage = Number(n)
      }
    },
    prevPage() {
      event.stopPropagation()
      if (!this.pageCount) return
      if (this.curPage !== 1) {
        this.page(null, this.curPage - 1)
      }
    },
    nextPage() {
      event.stopPropagation()
      if (!this.pageCount) return
      if (this.curPage !== this.pageCount) {
        this.page(null, this.curPage + 1)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pagination {
  position: relative;
  text-align: center;
  & > .desc {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    margin: 0;
    font-size: 14px;
    color: #333;
    padding-right:0.3rem;
  }
  ul {
    margin: 0;
    li {
      cursor: pointer;
      display: inline-block;
      padding: 4px 8px;
      border: 1px solid #e2e2e2;
      border-radius: 2px;
      margin-right: 6px;
      font-size: 0.16rem;
      color: #666666;
      &.active {
        background: #333;
        span {
          color: #fff;
        }
      }
      &.disabled {
       background: #F4F4F4;
      }
    }
  }
  a {
    color: #333;
    text-decoration: none;
    -webkit-tap-highlight-color: rgba(255, 0, 0, 0);
    cursor: pointer;
  }
}
</style>
